module.exports = {
  paymentType: "支付类型",
  card: "元宝/各种卡",
  gift: "礼包",
  characterId: "角色ID",
  characterName: "角色名称",
  server: "服务器",
  selectItem: "选择物品",
  confirmBtn: "确认",
  rechargeBtn: "立即充值",
  inputRoleId: "请输入角色ID并确认",
  noRoleId: "角色ID不存在，请重新输入",
  supplementAllInfo: "请补全完整的信息！",
  errorCharacterId: "角色ID有误",
  errorCharacterName: "角色名称不能为空",
  errorServer: "服务器不能为空",
  errorSelectItem: "选择物品不能为空",
  selectPayWay: "请选择您所在的国家并选择支付方式",
  introduce:
    "关于支付： <br>1、热血礼包、祝福礼包和经典礼包每日仅可购买一次；<br>2、在输入角色id后，请点击“comfirm”确认您的角色名和服务器ID，确认无误后，便可安心充值；<br>3、如果您在支付中遇到任何问题，请与fb客服联系：Yulang Global.",
  code: {
    603: "用户信息不存在",
    606: "商品不存在",
    607: "支付渠道不存在",
    605: "沒有设置兑换比例，请联系客服",
    608: "角色id不存在",
    609: "订单创建失败",
    610: "该服务器不允许存储",
    611: "您在该服务器未创建角色，请确认登录账号是否正确",
    612: "该服务器不存在",
    613: "支付请求",
    614: "通知游戏失败",
    615: "您输入的角色Id不存在"
  },
  rechargeSuccess: "充值完成",
  pleaseCheck: "奖励已在游戏内发放，请返回游戏查看",
  resultBtn: "确定",
  someQuestions: "若支付遇到问题，请联系FB客服@YulgangGlobalID "
};
